/* ReconnectAppendage.js */

"use strict";
// const _ = require('lodash');

class ReconnectAppendage {
    constructor(logger, steveCore, userSession, router, localStorage) {
        this._logger = logger;
        this._steve = steveCore;
        this._userSession = userSession;
        this._router = router;
        this._localStorage = localStorage;
    }

    // eslint-disable-next-line no-unused-vars
    startUp(opts) {
        let creds;

        let token = this._userSession.token;
        if (!token) {
            let routeData = this._router.getRouteData();
            token = routeData && routeData.token ? routeData.token : this._localStorage.getToken();
        }

        if (token) {
            creds = {username: "OTK", password: token};
        }

        // let routeDestSection = _.get(opts, "newRouteDetails.s", false);

        return Promise.resolve()
            .then(() => {
                if (creds) {
                    return this._userSession.login(creds);
                } else {
                    throw new Error("couldn't find an existing auth token");
                }
            })
            .then(() => true)
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "ShowHomeBarAppendage.startUp() - Unable to automatically login, routing to login screen"
                );
                // let dest = {app: "GameConsole", s: "LoginCenter", rd: {triggeredBy: "Startup"}};
                // if (routeDestSection) {
                //     dest.rd.redirect = {app: "GameConsole", s: routeDestSection};
                // }
                // this._router.goTo(dest);
                const token = this._userSession.token || this._localStorage.getToken();
                localStorage.clear();
                location.href = `${window.origin}/session/logout/${token}`;
                return false;
            });
    }
}

module.exports = ReconnectAppendage;
module.exports.$inject = [
    "$teve.logger",
    "$teve.core",
    "$teve.userSession",
    "$teve.router",
    "$teve.userLocalStorage",
];
